import React, { useEffect, useRef, useState } from 'react';
import { bool, arrayOf, object } from 'prop-types';
import clsx from 'clsx';
import CloseIcon from 'assets/images/icons/close-40x40.svg';
import useStore from 'state/state';
import useIsClickOutside from 'hooks/useIsClickOutside';
import styles from './DocumentsView.module.scss';
import Document from './Document/Document';

const DocumentsView = ({ isWhitePaper, data }) => {
  const setIsWhitePaperOpen = useStore((state) => state.setIsWhitePaperOpen);
  const setIsArticleOpen = useStore((state) => state.setIsArticleOpen);
  const [animateOut, setAnimateOut] = useState(false);
  const onClickOutside = useIsClickOutside();
  const listRef = useRef(null);
  const getMod = (index) => {
    if (index % 2 === 0) {
      return true;
    }
    return false;
  };

  const closeDocuments = () => {
    setAnimateOut(true);
    setTimeout(() => {
      setIsWhitePaperOpen(false);
      setIsArticleOpen(false);
    }, 500);
  };

  useEffect(() => {
    onClickOutside.setRef(listRef);
    onClickOutside.setCallbackFunc(() => {
      closeDocuments();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={clsx(styles.wrapper, { [styles.fadeOut]: animateOut })}>
      <button
        onClick={closeDocuments}
        type="button"
        label="tint"
        className={styles.tint}
      />
      <button
        type="button"
        label="close"
        onClick={closeDocuments}
        className={clsx(styles.closeIcon, { [styles.fadeOut]: animateOut })}
      >
        <CloseIcon />
      </button>
      <div className={styles.label}>
        {isWhitePaper ? 'White paper' : 'Artikel'}
      </div>
      <div className={styles.list} ref={listRef}>
        {data.map(
          (
            { overlineText, imageUrl, id, titleText, url, preambleText },
            key
          ) => (
            <Document
              key={id}
              isWhitePaper={isWhitePaper}
              isFirstChild={key === 0}
              imageRight={!getMod(key)}
              category={overlineText}
              title={titleText}
              description={preambleText}
              url={url}
              imgUrl={imageUrl}
              animateOut={animateOut}
            />
          )
        )}
      </div>
    </div>
  );
};

DocumentsView.propTypes = {
  isWhitePaper: bool,
  // eslint-disable-next-line react/forbid-prop-types
  data: arrayOf(object).isRequired,
};

DocumentsView.defaultProps = {
  isWhitePaper: false,
};

export default DocumentsView;
